// extracted by mini-css-extract-plugin
module.exports = {"youtubeVideoWrapper":"VideoAdaptors-YouTubeVideoAdaptor__youtubeVideoWrapper--V7JUt"};